<!-- Loading overlay -->
@if (isLoading()) {
  <dc-loading-page [message]="'Just a moment, we’re setting things up for you…'"></dc-loading-page>
} @else {
  <!-- Main app content -->
  <div class="main-content">
    <div class="main-container">
      <router-outlet></router-outlet>
    </div>
  </div>
}
<dc-toast></dc-toast>

<dc-smile-loader></dc-smile-loader>
